module.exports = __webpack_public_path__ + "stylesheets/section-vertical-text-video_c122572f93aae91a6761aa10efeacef5.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/landing-template/components/sections/section-vertical-text-video.less
// module id = MJwn
// module chunks = 118